
import { mapActions, mapGetters } from 'vuex'
export default {
  data() {
    return {
      loadingScheduling: false,
    }
  },
  head: {
    title: 'Agendamento',
  },
  computed: {
    ...mapGetters('sdagenda', ['sdagenda']),
  },

  mounted() {
    this.verifysdagenda()
  },

  methods: {
    ...mapActions('sdagenda', ['verifysdagenda']),
    ...mapActions('dataClient', ['fullyCleanCart']),
    Scheduling() {
      const idTransacao = this.$route.query.idTransacao
      this.loadingScheduling = true
      this.$router.push({
        path: '/agendamento',
        query: {
          idTransacao,
        },
      })
    },
    shedulingAfter() {
      this.$router.push('/')
      this.fullyCleanCart()
    },
  },
}
